module.exports = __webpack_public_path__ + "img/216.call_cleaner.5de134da.svg";